import React, {useState} from 'react';
import {
    withStyles,
    makeStyles,
} from '@material-ui/core/styles';
import InputBase from '@material-ui/core/InputBase';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import {FormHelperText, IconButton, InputAdornment} from "@material-ui/core";
import {Clear, Visibility, VisibilityOff} from "@material-ui/icons";

const BootstrapInput = withStyles((theme) => ({
    root: {
        marginTop: '0 !important',
        'label + &': {
            marginTop: theme.spacing(3),
        },
        '&.Mui-error input': {
            borderColor: '#7D1C24',
            '&:hover':{
                boxShadow: '0px 0px 0px 4px #F2B8B5',
            }
        }
    },
    input: {
        color: '#2F3337',
        borderRadius: '12px',
        position: 'relative',
        backgroundColor: '#FFF',
        border: '1px solid #E3E6E8',
        fontSize: '0.9rem',
        width: '100%',
        padding: '10px 12px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
        fontFamily: [
            'Poppins',
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(','),
        '&:focus': {
            borderColor: '#FFD799',
            backgroundColor: theme.palette.common.white,
        },
        '&:hover':{
            boxShadow: '0px 0px 0px 4px #FCEACE',
            borderColor: '#FFC160'
        }
    },
}))(InputBase);

const SmallBootstrapInput = withStyles((theme) => ({
    root: {
        marginTop: '0 !important',
        'label + &': {
            marginTop: theme.spacing(3),
        },
        '&.Mui-error input': {
            borderColor: '#7D1C24'
        }
    },
    input: {
        color: '#2F3337',
        borderRadius: '12px',
        position: 'relative',
        backgroundColor: '#FFF',
        border: '1px solid #E3E6E8',
        fontSize: '0.8rem',
        width: '100%',
        padding: '6px 8px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
        fontFamily: [
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(','),
        '&:focus': {
            borderColor: '#FFD799',
            backgroundColor: theme.palette.common.white,
        },
        '&:hover':{
            boxShadow: '0px 0px 0px 4px #FCEACE',
            borderColor: '#FFC160'
        }
    },
}))(InputBase);

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    margin: {
        width: '100%'
    },
    label: {
        color: '#758089 !important',
        fontSize: '0.9rem',
        fontWeight: 400,
        position: 'relative',
        lineHeight: '144%',
        transition: 'none',
        transform: 'none',
        marginBottom: '5px'
    }
}));

export const StyledInput: React.FC<Props> = ({id, label, onChange, onBlur, value, placeholder, type = 'text', error = false, smallInput = false, errorMessage = '', showClear = false}) => {
    const [showPassword, setShowPassword] = useState(false);
    const classes = useStyles();


    return (
        <FormControl error={error} className={classes.margin}>
            {label &&
                <InputLabel shrink htmlFor={id} className={classes.label}>
                    {label}
                </InputLabel>
            }
            {!smallInput ?
                <BootstrapInput id={id} name={id} onChange={onChange} onBlur={onBlur} value={value} placeholder={placeholder} type={(showPassword) ? 'text' : (type === 'percent' ? 'number' : type)} onKeyPress={e => { e.which === 13 && e.preventDefault() }} endAdornment={
                    ((type === 'password' &&
                        <InputAdornment position="end" style={{position: 'absolute', right: '5px'}}>
                            <IconButton
                                size="small"
                                aria-label="toggle password visibility"
                                onClick={() => {
                                    setShowPassword(!showPassword);
                                }}
                                onMouseDown={(event) => {
                                    event.preventDefault();
                                }}
                            >
                                {!showPassword ? <Visibility style={{color: '#C8CCD0'}} /> : <VisibilityOff style={{color: '#C8CCD0'}} />}
                            </IconButton>
                        </InputAdornment>
                    ) || (type === 'percent' &&
                        <InputAdornment position="end">
                            %
                        </InputAdornment>
                    ) || (showClear &&
                        <InputAdornment position="end" style={{position: 'absolute', right: '5px'}}>
                            <IconButton
                                size="small"
                                aria-label="clear text"
                                onClick={() => {
                                    onChange({target: {value: ''}});
                                }}
                                onMouseDown={(event) => {
                                    event.preventDefault();
                                }}
                            >
                                <Clear style={{color: '#C8CCD0'}} />
                            </IconButton>
                        </InputAdornment>
                    ))
                }/>
                :
                <SmallBootstrapInput id={id} name={id} onChange={onChange} onBlur={onBlur} value={value} placeholder={placeholder} type={(showPassword) ? 'text' : (type === 'percent' ? 'number' : type)} onKeyPress={e => { e.which === 13 && e.preventDefault() }} endAdornment={
                    ((type === 'password' &&
                        <InputAdornment position="end" style={{position: 'absolute', right: 0}}>
                            <IconButton
                                aria-label="toggle password visibility"
                                onClick={() => {
                                    setShowPassword(!showPassword);
                                }}
                                onMouseDown={(event) => {
                                    event.preventDefault();
                                }}
                            >
                                {!showPassword ? <Visibility style={{color: '#E3E6E8'}} /> : <VisibilityOff style={{color: '#E3E6E8'}} />}
                            </IconButton>
                        </InputAdornment>
                    ) || (type === 'percent' &&
                        <InputAdornment position="end">
                            %
                        </InputAdornment>
                    ) || (showClear &&
                        <InputAdornment position="end" style={{position: 'absolute', right: '5px'}}>
                            <IconButton
                                size="small"
                                aria-label="clear text"
                                onClick={() => {
                                    onChange({target: {value: ''}});
                                }}
                                onMouseDown={(event) => {
                                    event.preventDefault();
                                }}
                            >
                                <Clear style={{color: '#C8CCD0'}} />
                            </IconButton>
                        </InputAdornment>
                    ))
                }/>
            }
            {error && errorMessage &&
                <FormHelperText style={{color: '#DB575F'}}>
                    {errorMessage}
                </FormHelperText>
            }
        </FormControl>
    );
}

interface Props {
    id: string,
    label: string,
    onChange?: any,
    onBlur?: any,
    value?: any,
    placeholder?: string
    type?: 'text'|'password'|'percent'|'number';
    error?: boolean;
    errorMessage?: string;
    smallInput?: boolean,
    showClear?: boolean
}
